import axios from 'axios';

export const apiRegisterForCertification = (id, payload) =>
  axios.post(`/api/certification/${id}/registration`, payload);

export const apiPayCertificationFees = ({ token, ...payload }) =>
  axios.post(`/api/certification/pay`, { ...payload, stripeToken: token });

export const apiDeleteCertificationPayment = (userId, id) => axios.delete(`/api/admin/user/${userId}/payments/${id}`);

export const apiAdminGetAllCertifications = () => axios.get('/api/admin/certifications');
export const apiAdminEditCertification = ({ userId }, { id, ...payload }) =>
  axios.post(`/api/admin/user/${userId}/certification/${id}`, payload);
export const apiAdminReinstateCertification = ({ id, userId, ...payload }) =>
  axios.post(`/api/admin/user/${userId}/certification/${id}/reinstate`, payload);
export const apiManuallyRegisterForCertification = (id, payload) =>
  axios.post(`/api/admin/certification/${id}/registration`, payload);
export const apiManuallyPayForCertification = (payload) => axios.post(`/api/admin/certifications`, payload);
